import React, { useState } from 'react';
import { CatchPlaceIcon } from '../../../assets/icons';

interface DraggableProps {
  id: string;
  children?: React.ReactNode;
  className?: string;
  dragPreviewClassName?: string;
  dragPreviewStyle?: React.CSSProperties;
  onDragStart?: (e: React.DragEvent<HTMLDivElement>) => void;
  onDragEnd?: (e: React.DragEvent<HTMLDivElement>) => void;
}

export const Draggable: React.FC<DraggableProps> = ({
  id,
  children,
  className = '',
  dragPreviewClassName = '',
  dragPreviewStyle = {},
  onDragStart,
  onDragEnd,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
    e.dataTransfer.setData('text/plain', id);
    e.dataTransfer.effectAllowed = 'copyMove';
    setIsDragging(true);

    const dragPreview = e.currentTarget.cloneNode(true) as HTMLElement;

    if (dragPreviewClassName) {
      dragPreview.className = dragPreviewClassName;
    }

    if (dragPreviewStyle) {
      Object.assign(dragPreview.style, dragPreviewStyle);
    }

    if (!dragPreviewStyle && !dragPreviewClassName) {
      dragPreview.style.opacity = '0.8';
      dragPreview.style.transform = 'rotate(5deg)';
      dragPreview.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
      dragPreview.style.zIndex = '9999';
    }

    dragPreview.style.position = 'absolute';
    dragPreview.style.top = '-1000px';
    dragPreview.style.left = '-1000px';

    document.body.appendChild(dragPreview);
    e.dataTransfer.setDragImage(dragPreview, 0, 0);

    setTimeout(() => {
      if (document.body.contains(dragPreview)) {
        document.body.removeChild(dragPreview);
      }
    }, 100);

    if (onDragStart) {
      onDragStart(e);
    }
  };

  const handleDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
    setIsDragging(false);

    if (onDragEnd) {
      onDragEnd(e);
    }
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      className={`flex items-center border border-gray-200 bg-white rounded-md px-3 py-1 mb-1 cursor-move transition-all duration-200 font-mono text-tiny ${isDragging ? 'opacity-60' : ''} ${className}`}
      style={{ minHeight: '32px', minWidth: '180px' }}
    >
      <div className="mr-2">
        <CatchPlaceIcon color="#6B7280" width={16} height={16} />
      </div>

      <span className="truncate flex-1">{children || id}</span>
    </div>
  );
};
